// src/mocks/handlers/brands.handlers.js
import * as data from '../data/brands.demo';

export const getAllBrands = async () => data.allBrands;
export const getCategoryNames = async () => data.categoryNames;
export const getBrandQuantities = async () => data.brandQuantities;
export const getBrandVariables = async () => data.brandVariables;
